import React from "react";
import Defiswapconnect from "Pages/Defiswapconnect";


const Deficonnecttheme = () => {
  return (
    <React.Fragment>
       <Defiswapconnect/>
    </React.Fragment>
  );
};

export default Deficonnecttheme;
